"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _proptypes = require("../utils/proptypes");

var _Spin = _interopRequireDefault(require("../Spin"));

var _icons = _interopRequireDefault(require("../icons"));

var _is = require("../utils/is");

var _color = require("../utils/color");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Tag =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Tag, _PureComponent);

  function Tag(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      dismiss: 0
    };
    _this.dismiss = _this.dismiss.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderClose = _this.renderClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.closeTag = _this.closeTag.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Tag.prototype;

  _proto.closeTag = function closeTag() {
    this.setState({
      dismiss: 2
    });
  };

  _proto.dismiss = function dismiss(e) {
    var _this2 = this;

    var onClose = this.props.onClose;
    var callback;

    if (onClose === true) {
      this.closeTag();
      return;
    }

    if (typeof onClose === 'function') {
      callback = onClose(e);
    }

    if ((0, _is.isPromise)(callback)) {
      this.setState({
        dismiss: 1
      });
      callback.then(function () {
        _this2.closeTag();
      });
      return;
    }

    if (e.defaultPrevented) {
      return;
    }

    this.closeTag();
  };

  _proto.handleClick = function handleClick(e) {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        disabled = _this$props.disabled;
    if (disabled) return;
    if (typeof onClick === 'function') onClick(e);
  };

  _proto.handleClose = function handleClose(e) {
    var disabled = this.props.disabled;
    if (this.state.dismiss > 0 || disabled) return;
    this.dismiss(e);
  };

  _proto.renderClose = function renderClose(dismiss) {
    var onClose = this.props.onClose;
    if (!onClose) return null;
    var closeClass = (0, _styles.tagClass)('close-icon');
    var loadingClass = (0, _styles.tagClass)('close-loading');

    if (dismiss === 0) {
      return _react.default.createElement("div", {
        className: closeClass,
        onClick: this.handleClose
      }, _icons.default.Close);
    }

    return _react.default.createElement("div", {
      className: loadingClass
    }, _react.default.createElement(_Spin.default, {
      name: "ring",
      size: 10
    }));
  };

  _proto.render = function render() {
    var dismiss = this.state.dismiss;
    if (dismiss === 2) return null;
    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        type = _this$props2.type,
        backgroundColor = _this$props2.backgroundColor,
        onClose = _this$props2.onClose,
        disabled = _this$props2.disabled;
    var style = this.props.style;
    var tagClassName = (0, _styles.tagClass)('_', disabled && 'disabled', type);
    var inlineClassName = (0, _styles.tagClass)('inline');
    var click = !onClose ? {
      onClick: this.handleClick
    } : {};
    var tagStyle = style || {};
    if (className) tagClassName += " " + className;

    if (backgroundColor) {
      tagStyle = _objectSpread({
        color: (0, _color.isDark)(backgroundColor) ? '#fff' : '#000',
        backgroundColor: backgroundColor,
        borderColor: 'transparent'
      }, style);
    }

    return _react.default.createElement("div", _extends({
      className: tagClassName,
      style: tagStyle
    }, click), onClose ? _react.default.createElement("div", {
      onClick: this.handleClick,
      className: inlineClassName
    }, children) : children, this.renderClose(dismiss));
  };

  return Tag;
}(_component.PureComponent);

Tag.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'type'), {
  children: _propTypes.default.any,
  onClose: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
  backgroundColor: _propTypes.default.string
});
Tag.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  type: 'default'
});
var _default = Tag;
exports.default = _default;